import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { RequisitionService } from '../services/requisition.service';
import { Requisition } from '../models/requisition';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { ViewDossierDialogComponent } from '../view-dossier-dialog/view-dossier-dialog.component';
import { FreelancerFilter } from '../interfaces/filters';
import { SliderCvComponent } from '../slider-cv/slider-cv.component';
import { CvComponent } from '../cv/cv.component';
import { ViewCvComponent } from '../view-cv/view-cv.component';

@Component({
  selector: 'app-view-requisition',
  templateUrl: './view-requisition.component.html',
  styleUrls: ['./view-requisition.component.css']
})
export class ViewRequisitionComponent implements OnInit {

  public loading: boolean;
  public requisition: Requisition;
  public id: string;
  public jobId: string;
  public qa: boolean;
  private companyUrl = `${ environment.companyUrl }`;
  public freelancerFilter: FreelancerFilter;
  public freelancerAssingFilter: FreelancerFilter;
  public freelancerAsigned: boolean;

  constructor(
    private dialog: MatDialog,
    private requisitionService: RequisitionService,
    private route: ActivatedRoute) {
    this.loading = false;
    this.route.params.subscribe(params => {
      this.id = params['id'];
      if (typeof this.id !== 'undefined') {
        this.getRequisition(this.id);
      }
    });
  }

  ngOnInit() {

  }

  refreshFreelancerList() {
    this.getRequisition(this.requisition.id);
  }

  postNote() {
    console.log(this.requisition.notes);
    this.requisitionService.putRequisitionNotes(this.requisition.id, this.requisition.notes)
    .subscribe(
      res => {
        console.log('Update');
      },
      () => {
        console.log('Error retrieving Requisition');
        this.loading = false;
      }
    );
  }

  getRequisition(id) {
    this.loading = true;
    this.requisitionService.getRequisition(id)
    .subscribe(
      res => {
        this.loading = false;
        this.requisition = res;

        if (res.job) {
          this.jobId = res.job.id;
          this.freelancerFilter = {'jobId': this.jobId, 'assigned': 0};
        } else {
          console.log('job');
        }

        if (res.assigned_freelancers) {
          this.freelancerAssingFilter = {'company_user_id': res.assigned_freelancers.id};
        } else {
          console.log('job');
        }

        if (this.requisition.assigned_freelancers) {
          this.freelancerAsigned = true;
        } else {
          this.freelancerAsigned = false;
        }

        if (this.requisition.qa) {
          this.qa = true;
        } else {
          this.qa = false;
        }
      },
      () => {
        console.log('Error retrieving Requisition');
        this.loading = false;
      }
    );
  }

  openInforme() {
    console.log('openInforme');
    let dialogRef = this.dialog.open(ViewDossierDialogComponent, {
      data: {
        job: this.requisition.job,
        create: false,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getRequisition(this.requisition.id);
    });
  }

  openCreateOffer() {
    console.log('openCreateOffer');
    window.open(this.companyUrl + '/createoffer/requisition/' + this.id, '_blank');
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data:
      {message: 'Detalle de la Requisición', information: true, showIcon: true}});
  }

  openCV(user_id, job_id) {
    const data = {'userId': user_id, 'filters': ''};
    this.dialog.open(ViewCvComponent, {
      data: data
    });
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/view-requisition/view-requisition.component.ts